const activities = {
  en: {
    types: {
      CALL: 'Call',
      MEETING: 'Meeting',
      EMAIL: 'Email',
      TELEGRAM: 'Telegram',
      NOTE: 'Note',
      TASK: 'Task',
      STAGE_CHANGE: 'Stage change',
      SYSTEM: 'System',
    },
    common: {
      untitled: 'Untitled',
    },
    timeline: {
      emptyTitle: 'No activity yet',
      emptyDescription: 'Log a call, meeting, or task to start the timeline.',
      errorFailedToLoad: 'Failed to load activity',
      completeAction: 'Mark as done',
      deleteAction: 'Delete',
      dueOn: 'Due {date}',
      completedOn: 'Completed {date}',
    },
    composer: {
      typeLabel: 'Activity type',
      subjectPlaceholder: 'What happened, or what needs to happen?',
      dueAtLabel: 'Due date',
      submit: 'Add',
      submitting: 'Adding…',
      errorSubjectRequired: 'Please enter a subject.',
      errorFailedToCreate: 'Failed to add activity',
    },
    myTasks: {
      title: 'My tasks',
      overdue: 'Overdue',
      today: 'Today',
      upcoming: 'Upcoming',
      empty: 'You have no open tasks. Nice and tidy.',
      errorFailedToLoad: 'Failed to load your tasks',
      completeAction: 'Mark as done',
      viewAll: 'View all',
    },
    enrollmentBadges: {
      columnHeader: 'License',
      sourceLicense: 'B2B',
      sourcePaid: 'Paid',
      expiresOn: 'Expires {date}',
      expired: 'Expired',
      cohortColumn: 'Cohort',
    },
  },
  ru: {
    types: {
      CALL: 'Звонок',
      MEETING: 'Встреча',
      EMAIL: 'Email',
      TELEGRAM: 'Telegram',
      NOTE: 'Заметка',
      TASK: 'Задача',
      STAGE_CHANGE: 'Смена этапа',
      SYSTEM: 'Система',
    },
    common: {
      untitled: 'Без названия',
    },
    timeline: {
      emptyTitle: 'Пока нет активности',
      emptyDescription: 'Запишите звонок, встречу или задачу, чтобы начать историю.',
      errorFailedToLoad: 'Не удалось загрузить активность',
      completeAction: 'Отметить выполненным',
      deleteAction: 'Удалить',
      dueOn: 'Срок {date}',
      completedOn: 'Выполнено {date}',
    },
    composer: {
      typeLabel: 'Тип активности',
      subjectPlaceholder: 'Что произошло или что нужно сделать?',
      dueAtLabel: 'Срок выполнения',
      submit: 'Добавить',
      submitting: 'Добавление…',
      errorSubjectRequired: 'Пожалуйста, укажите тему.',
      errorFailedToCreate: 'Не удалось добавить активность',
    },
    myTasks: {
      title: 'Мои задачи',
      overdue: 'Просрочено',
      today: 'Сегодня',
      upcoming: 'Предстоящие',
      empty: 'У вас нет открытых задач. Всё чисто.',
      errorFailedToLoad: 'Не удалось загрузить ваши задачи',
      completeAction: 'Отметить выполненным',
      viewAll: 'Показать все',
    },
    enrollmentBadges: {
      columnHeader: 'Лицензия',
      sourceLicense: 'B2B',
      sourcePaid: 'Платно',
      expiresOn: 'Истекает {date}',
      expired: 'Истёк',
      cohortColumn: 'Когорта',
    },
  },
  uz: {
    types: {
      CALL: "Qo'ng'iroq",
      MEETING: 'Uchrashuv',
      EMAIL: 'Email',
      TELEGRAM: 'Telegram',
      NOTE: 'Eslatma',
      TASK: 'Vazifa',
      STAGE_CHANGE: 'Bosqich o\'zgarishi',
      SYSTEM: 'Tizim',
    },
    common: {
      untitled: 'Nomsiz',
    },
    timeline: {
      emptyTitle: 'Hozircha faoliyat yo\'q',
      emptyDescription: 'Tarixni boshlash uchun qo\'ng\'iroq, uchrashuv yoki vazifa qo\'shing.',
      errorFailedToLoad: 'Faoliyatni yuklab bo\'lmadi',
      completeAction: 'Bajarilgan deb belgilash',
      deleteAction: 'O\'chirish',
      dueOn: 'Muddati {date}',
      completedOn: 'Bajarildi {date}',
    },
    composer: {
      typeLabel: 'Faoliyat turi',
      subjectPlaceholder: 'Nima bo\'ldi yoki nima qilish kerak?',
      dueAtLabel: 'Bajarish muddati',
      submit: "Qo'shish",
      submitting: "Qo'shilmoqda…",
      errorSubjectRequired: 'Iltimos, mavzuni kiriting.',
      errorFailedToCreate: "Faoliyat qo'shib bo'lmadi",
    },
    myTasks: {
      title: 'Mening vazifalarim',
      overdue: 'Muddati o\'tgan',
      today: 'Bugun',
      upcoming: 'Kelayotgan',
      empty: 'Ochiq vazifalaringiz yo\'q. Hammasi tartibda.',
      errorFailedToLoad: 'Vazifalaringizni yuklab bo\'lmadi',
      completeAction: 'Bajarilgan deb belgilash',
      viewAll: "Hammasini ko'rish",
    },
    enrollmentBadges: {
      columnHeader: 'Litsenziya',
      sourceLicense: 'B2B',
      sourcePaid: 'Pullik',
      expiresOn: 'Muddati {date}',
      expired: "Muddati o'tgan",
      cohortColumn: 'Kohorta',
    },
  },
};

export default activities;
